module.exports = __webpack_public_path__ + "img/share.84116bbd.svg";